export default __webpack_public_path__ + "static/media/element_40.ff20d684.webp";